import { CommonModule } from "@angular/common";
import { Component, Input } from '@angular/core';
import { CmdAzzurroHubService } from "ngx-core-services";
import { SimpleButtonComponent } from "ngx-zcs-components";
import { BehaviorSubject } from "rxjs";

const getLabels = () => ({
  startRescan: 'Start Rescan',
  rescanDisclaimerTitle: 'Azzurro Hub Rescan',
  rescanDisclaimerText: 'This will rescan the Azzurro Hub and update the device list. Please ensure that the Azzurro Hub is connected and operational.',
  rescanningMessage: 'Azzurro Hub is rescanning devices, please wait...',
});

@Component({
  selector: 'lib-azzurro-hub-rescan',
  standalone: true,
  imports: [
    CommonModule,
    SimpleButtonComponent,
  ],
  template: `
    <section
      class="fx-col fx-gap-1 p-2 border-1 bg-accent-100 radius-4 border-accent-400">
      <p class="text-400 text-grey-400">
        {{ labels.rescanDisclaimerTitle }}
      </p>
      <div class="fx-row fx-center fx-justify-between">
        <p class="text-grey-400">
          {{ labels.rescanDisclaimerText }}
        </p>
        <customer-simple-button
          type="primary"
          [disabled]="!canRescan"
          [label]="labels.startRescan"
          [action]="rescanDevices">
        </customer-simple-button>

      </div>
    </section>`,
  styleUrls: [],
})
export class AzzurroHubRescanComponent {
  @Input() canRescan = false;
  @Input() deviceId?: string;

  _labels = getLabels();
  readonly labels$ = new BehaviorSubject<typeof this._labels>(this._labels);
  @Input() set labels(value: Partial<typeof this._labels>) {
    Object.assign(this._labels, value);
    this.labels$.next(this._labels);
  }
  get labels(): typeof this._labels {
    return this._labels;
  }


  constructor(private readonly cmdAzzurroHubService: CmdAzzurroHubService) {
    this.rescanDevices = this.rescanDevices.bind(this);
  }

  async rescanDevices(): Promise<void> {
      if ( !this.canRescan || !this.deviceId) {
          return;
      }

      await this.cmdAzzurroHubService.rescanDevices(this.deviceId, this.labels.rescanningMessage);
    }
}
